angular
  .module 'memberPortal'
  .controller 'MemberProfileCtrl', (
    $scope,
    $stateParams,
    $sce,
    DataService
  ) ->
    $scope.data = DataService
    $scope.hash = $stateParams.m
    $scope.member = DataService.member_details

    $scope.barcode = $sce.trustAsHtml $scope.member.barcode_object_html
